import { PostmarkBounceResponses } from '@site-mate/dashpivot-shared-library';

export const PostmarkWebhookErrorCodes = {
  [PostmarkBounceResponses.HardBounce]: {
    label: 'Error - Hard Bounce',
    class: 'warning-status',
    popover:
      'The invite email could not be sent because the email is invalid or doesn’t exist. Please check the email spelling or try again.',
  },

  [PostmarkBounceResponses.ISP]: {
    label: 'Error - ISP',
    class: 'warning-status',
    popover:
      'The invite email was rejected by the recipient’s mail provider and not delivered. Please ask the recipient to whitelist dashpivot.com and try again.',
  },

  [PostmarkBounceResponses.Sent]: {
    label: 'Sent',
    class: 'success-status',
  },

  [PostmarkBounceResponses.MISC]: {
    label: 'Error - MISC',
    class: 'warning-status',
    popover: 'An error has occurred, please try again.',
  },
};
